(()=>{
  const root=document.querySelector('[data-madar-product-customizer]');
  if(!root)return;
  const svg=()=>{const s=`<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120"><rect width="120" height="120" rx="14" fill="#faf9f6"/><path d="M29 36h62l-6 62H35z" fill="#b98b55" stroke="#292929" stroke-width="3"/><rect x="47" y="46" width="26" height="10" rx="5" fill="#faf9f6" stroke="#292929" stroke-width="3"/></svg>`;return 'data:image/svg+xml;charset=UTF-8,'+encodeURIComponent(s)};
  function apply(){
    if(root.dataset.profile!=='bags')return;
    const field=root.querySelector('.madar-visual-field');
    const img=field?.querySelector('.madar-visual-option__media img');
    if(img&&!img.dataset.madarBagDieCut){img.src=svg();img.dataset.madarBagDieCut='1'}
  }
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',apply,{once:true}):apply();
  new MutationObserver(apply).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['data-profile']});
})();